import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useMutation,useQuery, useLazyQuery } from '@apollo/react-hooks'
import { coursesQueries, modulesQueries } from '../../graphql/queries'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import LoadingCourses from '../gridCoursesList/LoadingCourses'
import CoursesError from '../CoursesError'
import { certifiedMutations } from '../../graphql/mutations/'
import Button from '@material-ui/core/Button';
import { userQueries } from '../../graphql/queries/'
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';


function createData(name, progresso, actions) {
    return { name, progresso, actions };
}

  function verificaCertificado(data){

    const emite = data.emiteCertificado;
    const progresso = data.progresso;
    const requisito = data.requisitoCertificado;
   
    if(!emite){
      return false;
    }
    if(progresso >= parseInt(requisito) ){      
      return true;
    }else{
      return false;
    }

  }

 

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    padding: '1px 16px 24px',
    marginTop: '30px',
    overflow: 'hidden'
  },
  icon: {
    fontSize: '32px'
  },
  title: {
    marginBottom: '10px'
  },
  passwordIcon: {
    fontSize: '20px'
  }, 
  hr: {
    marginTop: '30px',
    marginBottom: '10px'
  },
  circularLoading: {
    margin: 'auto',
    alignSelf: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}))
const Content = () => {
  const classes = useStyles()
  var { data: user } = useQuery(userQueries.GET_USER)   
  const rows =[] 
  const { loading, error, data, refetch } = useQuery(coursesQueries.GET_COURSES_ALL)
  const isDefaultBreakpoint = useMediaQuery('(min-width:1050px)')
  const [geraCertificado,{loading:load,data: urlCertificado, error:err}] = useMutation(certifiedMutations.GENERATE_CERTIFICATE,{
    onCompleted(urlCertificado){         
      window.open(urlCertificado.geraCertificado.url);
    },
    onError(err){ 
      console.log(err)
  
    }

  })

  const [success, setSuccess] = React.useState(false);

  function gerasCertificado(valor){
    let curso_id = valor._id       
    geraCertificado({variables:{
      curso_id,
      user: user.usuario.nome + ' ' + user.usuario.sobrenome
      }  }) 

    if (!load) {
      setSuccess(false);
    }
  }

  function btn(valor){
    return ( 
    <Box sx={{ m: 1, position: 'relative' }}>
         {load && (
          <CircularProgress
          size={24}
          sx={{
            color: green[500],
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
        />
      ) || (
        <Button onClick={(e)=>{ e.preventDefault(); gerasCertificado(valor)}}>Gerar certificado</Button>
      
      )}
    
    </Box>

    )
  
  }

  if(data){
    let dados = data.cursos_all
    for(var i=0; i<dados.length; i++){
      rows.push(createData(dados[i].titulo, dados[i].progresso, verificaCertificado(dados[i])? btn(dados[i])  :
      <Button >Certificado não disponivel</Button>    ))
    }
  }

  const [loadModule, { loading: loadingModule, data: modulo }] = useLazyQuery(modulesQueries.GET_MODULES, { fetchPolicy: "network-only" })

  useEffect(() => {
    loadModule()
  }, [])  // eslint-disable-line

  if (loading || loadingModule || !modulo) return <LoadingCourses />
  if (error) return <CoursesError refresh={refetch} />
    
  return isDefaultBreakpoint ? (

    <>
    <TableContainer style={{marginTop: 50}} component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Curso</TableCell>
            <TableCell align="right">Progresso</TableCell>
            <TableCell align="right">Ações</TableCell>           
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.progresso}%</TableCell>
              <TableCell align="right">{row.actions}</TableCell>           
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    </>
  ): (
    <>
    {rows.map((row) => (
    <Card className={classes.root}>
      <CardContent>       
        <Typography variant="h5" component="h2">
         {row.name}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          Progresso: {row.progresso}%
        </Typography>     
      </CardContent>
      <CardActions>
          {row.actions}
      </CardActions>
    </Card>
    ))}
    </>
  )
  
}


export default Content